export interface SpecialArticle {
  id: string;
  title: string;
  excerpt: string;
  movieId: string;
  author: string;
  date: string;
  readCount: number;
}

export interface Special {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  intro: string;
  reason: string;
  articles: SpecialArticle[];
  related: string[];
}

export const specials: Special[] = [
  {
    id: "s1",
    title: "宇宙尽头的浪漫",
    subtitle: "科幻电影中的情感内核专题",
    cover: "https://readdy.ai/api/search-image?query=Artistic%20space%20nebula%20with%20warm%20amber%20and%20deep%20navy%20gradients%2C%20dreamy%20cinematic%20composition%2C%20high%20detail%20digital%20painting%2C%20no%20text&width=1200&height=675&seq=special-s1-cover-2026&orientation=landscape",
    intro: "当我们谈论科幻，常常先想到的是宏大的设定与炫目的特效。但有那么一批作品，把最遥远的星辰当作舞台，讲述的却是最贴近人心的情感。这个专题，我们想聊聊那些在宇宙尺度下依然动人的爱与牵挂。",
    reason: "选择这个专题，是因为科幻并不等于冰冷。恰恰相反，当背景被推向无限，人类的渺小与执念反而被放大得格外清晰，那些关于回家、关于承诺的故事，也因此拥有了超越类型的力量。",
    articles: [
      {
        id: "a1",
        title: "《星际远征》：时间是最残酷的情敌",
        excerpt: "在相对论的世界里，一次远征意味着错过的十几年。影片用时间的错位，把父女之情拍成了一场无法追回的遗憾，也让我们重新思考，什么才值得跨越光年。",
        movieId: "m1",
        author: "影评人·林深",
        date: "2024-09-18",
        readCount: 12480,
      },
      {
        id: "a2",
        title: "《虫洞边缘》：记忆是否就是我们本身",
        excerpt: "当一段记忆可以被加密、传输、篡改，我们还是原来的自己吗？这部作品用一场解谜，对'自我'这个概念发起了温柔而尖锐的追问。",
        movieId: "m12",
        author: "影评人·周航",
        date: "2024-08-30",
        readCount: 9100,
      },
      {
        id: "a3",
        title: "《机械黎明》：当机器学会说'我不想'",
        excerpt: "真正的觉醒不是拥有了智慧，而是拥有了拒绝的权利。影片对人工智能的刻画，最终指向的其实是人类自身对自由的渴望与恐惧。",
        movieId: "m8",
        author: "影评人·沈知",
        date: "2024-07-22",
        readCount: 11260,
      },
    ],
    related: ["s2", "s3"],
  },
  {
    id: "s2",
    title: "雨夜与真相",
    subtitle: "悬疑犯罪片的氛围美学专题",
    cover: "https://readdy.ai/api/search-image?query=Moody%20rainy%20city%20street%20at%20night%20with%20amber%20reflections%20on%20wet%20asphalt%20and%20deep%20navy%20shadows%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=special-s2-cover-2026&orientation=landscape",
    intro: "雨、霓虹、潮湿的街道、若隐若现的真相——悬疑犯罪片有着一套属于自己的视觉语言。好的氛围不只是为了好看，它本身就是叙事的一部分，在观众意识到之前，就悄悄埋下了不安的种子。",
    reason: "我们想拆解那些让人印象深刻的悬疑作品，看看它们是如何用光线、湿度与沉默，把观众一点点拖进谜团的。氛围，是这类电影最被低估的主角。",
    articles: [
      {
        id: "a4",
        title: "《暗夜追凶》：让雨成为叙事的共犯",
        excerpt: "为什么犯罪片总爱下雨？在这部作品中，雨不仅是背景，更是情绪的放大器，是真相被冲刷又浮现的隐喻。",
        movieId: "m2",
        author: "影评人·顾寒",
        date: "2024-09-05",
        readCount: 9630,
      },
      {
        id: "a5",
        title: "《沉默证词》：最响亮的表达是沉默",
        excerpt: "当所有人都在说话，唯一拒绝开口的人反而成了焦点。影片把'沉默'这个动作本身，变成了一场无声的控诉。",
        movieId: "m9",
        author: "影评人·苏语",
        date: "2024-08-12",
        readCount: 5980,
      },
      {
        id: "a6",
        title: "《迷雾之城》：集体遗忘的恐怖",
        excerpt: "比有人撒谎更可怕的，是整座城市达成了遗忘的默契。影片用一个悬案，拷问了记忆与真相之间的关系。",
        movieId: "m5",
        author: "影评人·沈知",
        date: "2024-06-28",
        readCount: 6890,
      },
    ],
    related: ["s1", "s3"],
  },
  {
    id: "s3",
    title: "归途与告别",
    subtitle: "家庭剧情片中的和解专题",
    cover: "https://readdy.ai/api/search-image?query=Warm%20golden%20hour%20countryside%20road%20with%20deep%20navy%20shadows%2C%20nostalgic%20cinematic%20wide%20composition%2C%20high%20detail%20digital%20painting%2C%20no%20text&width=1200&height=675&seq=special-s3-cover-2026&orientation=landscape",
    intro: "在所有的电影类型里，家庭剧情片或许是最接近生活的。它没有超级英雄，没有惊天爆炸，只有餐桌上的沉默、未寄出的信、和那些迟到了很多年的道歉。但正是这些，最容易被我们忽略，也最容易击中我们。",
    reason: "这个专题献给所有曾在家庭关系里感到过无力的人。这些电影不提供标准答案，它们只是安静地告诉你：和解，什么时候都不算太晚。",
    articles: [
      {
        id: "a7",
        title: "《归途》：把告别拍成一封没寄出的信",
        excerpt: "影片用一段返乡之旅，串联起一个人与家庭之间漫长而沉默的岁月。它告诉我们，有些话不说出口，就真的来不及了。",
        movieId: "m3",
        author: "影评人·林深",
        date: "2024-09-20",
        readCount: 7240,
      },
      {
        id: "a8",
        title: "《静默海洋》：安静，也可以震耳欲聋",
        excerpt: "一位失聪的灯塔守护者，一场纸上对话。影片用极简的叙事，探讨了孤独、存在与被理解的渴望。",
        movieId: "m15",
        author: "影评人·周航",
        date: "2024-08-01",
        readCount: 4880,
      },
      {
        id: "a9",
        title: "《心之所向》：成年人的选择没有满分",
        excerpt: "留在大城市，还是回到故乡？影片没有给出答案，却让每个在十字路口的人都感到了被理解。",
        movieId: "m7",
        author: "影评人·苏语",
        date: "2024-07-15",
        readCount: 5460,
      },
    ],
    related: ["s1", "s2"],
  },
];

export const getSpecialById = (id: string): Special | undefined =>
  specials.find((s) => s.id === id);